import InsideProdigiMobile from './InsideProdigiMobile';

export default InsideProdigiMobile;
